var $ = require('jquery');
const d3 = require("d3");
var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");
var commaFormat = d3.format(',');
/////////////////// NEW CASES AND DEATHS CHART /////////////
 var myFunction1 = function(updateData, idClicked, countyLabel, monthTicks, ap_months, dateNew) {
   var conWidth = $("#newbarChart").width();
   var conHeight = (conWidth > 500) ? 350 : 220;

   var innerColumns2 = {
     "column1" : [`${countyLabel}`],
   }

      $('#graph').empty();

      var margin = {top: 0, right: 0, bottom: 20, left: 55},
          width = conWidth - margin.left - margin.right,
          height = conHeight - margin.top - margin.bottom;

      var x0 = d3.scaleBand().range([0, width]).padding(.05);
      var x1 = d3.scaleBand().padding(.05);

      var y = d3.scaleLinear()
          .range([height, 0]);

      var xAxis = d3.axisBottom()
          .scale(x0)
          .tickValues(monthTicks)
          .tickFormat((d, i) => {
            var split_date = d.split("/");
            var year = split_date[2];
            year = year.slice(2);
            return `${split_date[0]}/${year}`;
          });


      var yAxis = d3.axisLeft()
          .scale(y).ticks(5);

          xAxis.tickSizeOuter(0);


      var svg1 = d3.select("#newbarChart #graph").append("svg")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
        .append("g")
          .attr("class","mainGraphic")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      var yBegin;

       var prevDayData = 0;

       var columnHeaders = d3.keys(updateData[0]).filter(function(key) { return (key === countyLabel) && (key === `${countyLabel}Avg`) });
       var totalCases = 0;
       var prevDay = 0;
       var allCoun = 0;
       var kingNew = 0;
       var kingPrev = 0;

       updateData.forEach(function(d) {
         allCoun = countyLabel === "CasesNew" ? parseInt(d.CasesNew) : parseInt(d.DeathsNew);
         var thisThing;

         var yColumn = new Array();
         d.columnDetails = columnHeaders.map(function(name) {
           for (ic in innerColumns2) {
             if($.inArray(name, innerColumns2[ic]) >= 0){
               // console.log(innerColumns2[ic]);
               if (!yColumn[ic]){
                 yColumn[ic] = 0;
               }
               yBegin = yColumn[ic];
               yColumn[ic] += +d[name];

               if (name === countyLabel) {
                 totalCases = parseInt(d[name]);
               } else {
                 totalCases = parseInt(d[name]) - prevDay;
                 prevDay = parseInt(d[name]);
               }
              thisThing = ic;

              return {name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin};
             }
           }
         });

         d.total = allCoun;
         d.allCoun = allCoun;
         d.column = thisThing;
       });



       x0.domain(updateData.map(function(d) { return d.Date; }));
       x1.domain(d3.keys(innerColumns2)).range([0, x0.bandwidth()]);
       y.domain([0, d3.max(updateData, function(d) { return d.allCoun;  })]);
       svg1.selectAll(".axis").remove();

       svg1.append("g")
           .attr("class", "x axis")
           .attr("transform", "translate(0," + (height + 0) + ")")
           .call(xAxis);


       svg1.append("g")
           .attr("class", "y axis")
           .call(yAxis)
         .append("text")
           .attr("transform", "rotate(-90)")
           .attr("y", 6)
           .attr("dy", ".7em")
           .style("text-anchor", "end")
           .text("");


           svg1.selectAll(".gBar").remove();


           var project_stackedbar1 = svg1.selectAll(".project_stackedbar")
               .data(updateData)
             .enter().append("rect")
               .attr("class", "gBar")
               .attr("id", function(d,i) {
                 return ("g" + i);
               })
               .attr("transform", function(d) { return "translate(" + x0(d.Date) + ",0)"; })
               .attr("width", x1.bandwidth())
               .attr("data-total", function(d) {
                 return d.total;
               })
               .attr("data-avg", function(d) {
                 var theRightAvg = (countyLabel === "CasesNew") ? d.CasesNewAvg : d.DeathsNewAvg;
                 return theRightAvg;
               })
               .attr("data-date", function(d) {
                 clickedDate = d.Date;
                 clickedDate = clickedDate.split("/");
                 var clickedMonth = parseInt(clickedDate[0]) - 1;

                 return (ap_months[clickedMonth] + " " + clickedDate[1]);
               })
               .transition()
               .duration(600)
               .attr("x", function(d) {
                 return x1(d.column);
                })
               .attr("y", function(d) {
                 return ((d.total > 0) ? y(d.total) : y( d.total + Math.abs(d.total) ));
               })
               .attr("height", function(d) {
                 // console.log(y(0) - y(d.total));
                 if (d.total > 0) {
                   return y(0) - y(d.total);
                 } else {
                   return y(d.total) - y(0);
                 }

               })
               .style("fill", function(d) {
                return ((idClicked === "casesCounty3") ? "#D8894E" : "#D15959");
              });

                const lastDayData2 = updateData[updateData.length - 1];
                $('.newTooltip #date').empty().append(dateNew);
                var theRightNumber2 = (countyLabel === "CasesNew") ? lastDayData2.CasesNew : lastDayData2.DeathsNew;
                var newFollow2 = (countyLabel === "CasesNew") ? " cases" : " deaths";
                var newAvg2 = (countyLabel === "CasesNew") ? lastDayData2.CasesNewAvg : lastDayData2.DeathsNewAvg;
                $('.newTooltip #total').empty().append(commafy(theRightNumber2) + newFollow2);
                $('.newTooltip #avg').empty().append(commafy(newAvg2));



                //define the line
                var valueline = d3.line()
                    .x(function(d) { return x0(d.Date) + (x0.bandwidth() / 2); })
                    .y(function(d) {
                      var theRightAvg = (countyLabel === "CasesNew") ?  y(d.CasesNewAvg) :  y(d.DeathsNewAvg);
                      return theRightAvg;
                    });

                svg1.append("path")
                    .data([updateData])
                    .attr("class", "line")
                    .attr("fill", "none")
                    .attr("stroke", "#aaa")
                    .attr("stroke-width", 2)
                    .attr("d", valueline);



                    //   // Create a rect on top of the svg area: this rectangle recovers mouse position
                  var eventCapture2 = svg1
                    .append('rect')
                    .style("fill", "none")
                    .style("pointer-events", "all")
                    .attr('width', width)
                    .attr('height', height)
                    .on('mousemove', mousemoveMe);

                    var focusContainer2 = svg1
                      .append('g')
                      .attr("class", "focusCon2");

                  var guideLine2 = focusContainer2.append("line")
                     .attr("class", "guideLine")
                     .attr("x1", width)
                     .attr("y1", 0)
                     .attr("x2", width)
                     .attr("y2", height)
                     .attr("stroke", "#7b7b7b")
                     .attr("stroke-dasharray","4");


                  x0.invert = (function(){
                   var domain = x0.domain()
                   var range = x0.range()
                   var scale = d3.scaleQuantize().domain(range).range(domain)

                     return function(x){
                         return scale(x)
                     }
                 })();

                 function mousemoveMe(e) {
                   var xy = d3.mouse(eventCapture2.node());
                   var d = x0.invert(xy[0]);
                   var nx = x0(d) + (x0.bandwidth()/2);

                   guideLine2.transition().duration(10).attr("x1", nx).attr("x2", nx);
                   const isDateTheSame = (element) => element.Date === d;

                   var i = updateData.findIndex(isDateTheSame);

                   selectedData = updateData[i];
                   var rawDate = selectedData.Date;

                   rawDate = rawDate.split("/");
                   var h_Month = rawDate[0];
                   var h_Day = rawDate[1];


                   h_Month = parseInt(h_Month) - 1;
                   var formatted_date = ap_months[h_Month] + " " + h_Day + ", " + rawDate[2];

                   $('.newTooltip #date').empty().append(formatted_date);
                   var theRightNumber = (countyLabel === "CasesNew") ? selectedData.CasesNew : selectedData.DeathsNew;
                   var newFollow = (countyLabel === "CasesNew") ? " cases" : " deaths";
                   var newAvg = (countyLabel === "CasesNew") ? selectedData.CasesNewAvg : selectedData.DeathsNewAvg;
                   $('.newTooltip #total').empty().append(commafy(theRightNumber) + newFollow);
                   $('.newTooltip #avg').empty().append(commafy(newAvg));

                   }
       }



  // $( ".radioButton3" ).click(function() {
  //   var cOrD = this.getAttribute('data-type');
  //   var thisID = $(this).attr("id");
  //   $('.title').toggleClass("showMe");
  //
  //   myFunction1(dohNumbers, thisID, `${cOrD}New`);
  // });

module.exports = myFunction1;
// myFunction1(dohNumbers, "casesCounty3", "CasesNew");
